import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.find.js";
import { formatTimelessDateStr } from "../../../utils/dates";
import { assert } from "../../../utils/assert";
import { ProgramType, useApplication } from "./application";
import { useApplicationConfiguration } from "./applicationConfiguration";
import { useApplicationPagePermissions } from "./permissions";
import { useApplicationPageAggregatedData } from "./aggregatedData";
import sortBy from 'lodash/sortBy';
export var IntakeStatus = /*#__PURE__*/function (IntakeStatus) {
  IntakeStatus["OPEN"] = "open";
  IntakeStatus["OPEN_CONDITIONALLY"] = "open_conditionally";
  IntakeStatus["WILL_OPEN"] = "will_open";
  IntakeStatus["WILL_OPEN_CONDITIONALLY"] = "will_open_conditionally";
  IntakeStatus["CLOSED"] = "closed";
  IntakeStatus["CLOSED_CONDITIONALLY"] = "closed_conditionally";
  IntakeStatus["LIKELY_OPEN"] = "likely_open";
  IntakeStatus["WAITLIST"] = "waitlist";
  return IntakeStatus;
}({});
export function useIntakes() {
  var _useApplicationPageAg = useApplicationPageAggregatedData({
      select: function select(aggregatedData) {
        var _aggregatedData$inclu;
        return (_aggregatedData$inclu = aggregatedData.included.filter(function (item) {
          return item.type === 'intake';
        })) === null || _aggregatedData$inclu === void 0 ? void 0 : _aggregatedData$inclu.map(function (intakeInsight) {
          return intakeInsight.attributes;
        });
      }
    }),
    data = _useApplicationPageAg.data;
  var eslIntakes = data === null || data === void 0 ? void 0 : data.filter(function (intake) {
    return intake.programType === ProgramType.Esl;
  });
  var academicIntakes = data === null || data === void 0 ? void 0 : data.filter(function (intake) {
    return intake.programType === ProgramType.Main;
  });
  return {
    intakes: data || [],
    eslIntakes: eslIntakes || [],
    academicIntakes: academicIntakes || []
  };
}
export var generateIntakeOptions = function generateIntakeOptions(_ref) {
  var selectedIntake = _ref.selectedIntake,
    intakes = _ref.intakes,
    useIds = _ref.useIds;
  return sortBy(intakes, 'startDate').map(function (intake) {
    return {
      label: "".concat(formatTimelessDateStr(intake.startDate, 'YYYY - MMMM')).concat(intake.startDate === selectedIntake ? ' (Current)' : ''),
      value: useIds ? intake.intakeId.toString() : intake.startDate
    };
  });
};
export function useApplicationMainIntake() {
  var _mainIntake$seatAvail2;
  var _useApplication = useApplication(),
    application = _useApplication.application;
  var _useApplicationConfig = useApplicationConfiguration(),
    applicationConfiguration = _useApplicationConfig.applicationConfiguration;
  var _useIntakes = useIntakes(),
    intakes = _useIntakes.intakes;
  var academicProgram = application.programs.find(function (program) {
    return program.programType === ProgramType.Main;
  });
  assert(academicProgram, 'Application missing academic program');
  var mainIntake = intakes.find(function (intake) {
    return intake.programType === ProgramType.Main && intake.startDate === academicProgram.startDate;
  });
  var mainIntakeScoreLevel = applicationConfiguration === null || applicationConfiguration === void 0 ? void 0 : applicationConfiguration.applicationSuccessScoreLevels.find(function (score) {
    var _mainIntake$seatAvail;
    return score.level === (mainIntake === null || mainIntake === void 0 ? void 0 : (_mainIntake$seatAvail = mainIntake.seatAvailability) === null || _mainIntake$seatAvail === void 0 ? void 0 : _mainIntake$seatAvail.determination);
  });
  var isMainIntakeBelowCtaThreshold = (applicationConfiguration === null || applicationConfiguration === void 0 ? void 0 : applicationConfiguration.viewSuccessScoreCtaThreshold) && (mainIntake === null || mainIntake === void 0 ? void 0 : mainIntake.seatAvailability) && (mainIntake === null || mainIntake === void 0 ? void 0 : (_mainIntake$seatAvail2 = mainIntake.seatAvailability) === null || _mainIntake$seatAvail2 === void 0 ? void 0 : _mainIntake$seatAvail2.score) < applicationConfiguration.viewSuccessScoreCtaThreshold;
  return {
    isMainIntakeBelowCtaThreshold: isMainIntakeBelowCtaThreshold,
    mainIntake: mainIntake,
    mainIntakeScoreLevel: mainIntakeScoreLevel
  };
}
export function useDisplaySuccessScore() {
  var _useApplicationPagePe = useApplicationPagePermissions(),
    permissions = _useApplicationPagePe.permissions;
  var _useApplication2 = useApplication(),
    stageId = _useApplication2.application.stageId;
  var _useApplicationMainIn = useApplicationMainIntake(),
    mainIntakeScoreLevel = _useApplicationMainIn.mainIntakeScoreLevel;
  var displaySuccessScore = (permissions === null || permissions === void 0 ? void 0 : permissions.view_insights) && mainIntakeScoreLevel && (stageId === 'pre-payment' || stageId === 'pre-submission' || stageId === 'submission');
  return {
    displaySuccessScore: displaySuccessScore
  };
}
export function useApplicationEslIntake() {
  var _useApplication3 = useApplication(),
    application = _useApplication3.application;
  var _useIntakes2 = useIntakes(),
    intakes = _useIntakes2.intakes;
  var eslProgram = application.programs.find(function (program) {
    return program.programType === ProgramType.Esl;
  });
  var eslIntake = intakes.find(function (intake) {
    return intake.programType === ProgramType.Esl && intake.startDate === (eslProgram === null || eslProgram === void 0 ? void 0 : eslProgram.startDate);
  });
  return {
    eslIntake: eslIntake
  };
}